function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPrivate = function SvgPrivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23761"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17778",
    d: "M10.667 13v1.667m-5 3.333h10a1.667 1.667 0 0 0 1.667-1.667v-5a1.667 1.667 0 0 0-1.667-1.667h-10A1.667 1.667 0 0 0 4 11.333v5A1.667 1.667 0 0 0 5.667 18ZM14 9.667V6.333a3.333 3.333 0 1 0-6.667 0v3.334Z",
    transform: "translate(1.25 .75)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20088",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
};

export default SvgPrivate;